import { render, staticRenderFns } from "./InspectionItemComponent.vue?vue&type=template&id=abd199c8&"
import script from "./InspectionItemComponent.vue?vue&type=script&lang=js&"
export * from "./InspectionItemComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports